exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zoom-area {\n    fill: transparent;\n    cursor: pointer;\n}\n\n.y-tick {\n    stroke: black;\n    fill: none;\n    stroke-width: 1px;\n}\n\n.line-separator, .x-axis {\n    stroke: black;\n    fill: none;\n    stroke-width: 1px;\n}\n\n.line-separator:last-child {\n    display: none;\n}\n\n.x-axis {\n    position: absolute;\n    z-index: 50;\n}\n\ntext {\n    stroke: none;\n    fill: black;\n}\n\n.graph-body .line {\n    height: 20px;\n    padding: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/style.css
// module id = ../../../../ansyn-event-drops/dist-es5/style.css
// module chunks = vendor